import { bindable, computedFrom } from 'aurelia-framework';
import moment from 'moment';

class SearchResults {
  @bindable loading = false;
  @bindable results = [];
  @bindable total;
  @bindable from;
  @bindable to;
  @bindable canLoadMore;
  @bindable canGoBack;
  @bindable onLoadMore;
  @bindable onGoBack;
  @computedFrom('results')
  get resultsByDay() {
    const byDay = {};
    this.results.forEach((item) => {
      const itemMoment = moment(item.published);
      const itemDay = itemMoment.format('MMM Do YY');
      if (!byDay[itemDay]) {
        byDay[itemDay] = {
          id: Math.floor(Number(itemMoment.format('X'))),
          label: itemDay,
          items: [],
        };
      }

      byDay[itemDay].items.push(item);
    });

    return Object.keys(byDay).map((day) => byDay[day]);
  }
  @computedFrom('results', 'loading')
  get showResults() {
    return !this.loading && this.results.length;
  }
  @computedFrom('from')
  get paginationStart() {
    return Math.max(Number(this.from), 1);
  }
}

export { SearchResults };
